import React, { useEffect, useRef } from "react";

const RENDER_PROFILE_FLAG = "__render_profile__";

function canUseDom() {
  return typeof window !== "undefined";
}

export function isRenderProfilingEnabled() {
  if (process.env.NODE_ENV === "production" || !canUseDom()) {
    return false;
  }

  if (window.__RENDER_PROFILING__ === true) {
    return true;
  }

  try {
    return window.localStorage.getItem(RENDER_PROFILE_FLAG) === "1";
  } catch {
    return false;
  }
}

function getChangedKeys(previousValues, nextValues) {
  const keys = new Set([
    ...Object.keys(previousValues || {}),
    ...Object.keys(nextValues || {}),
  ]);

  return Array.from(keys).filter(
    (key) => !Object.is(previousValues?.[key], nextValues?.[key])
  );
}

export function useRenderTrace(name, trackedValues = {}) {
  const renderCountRef = useRef(0);
  const previousValuesRef = useRef(trackedValues);

  renderCountRef.current += 1;

  useEffect(() => {
    if (!isRenderProfilingEnabled()) {
      previousValuesRef.current = trackedValues;
      return;
    }

    const changedKeys = getChangedKeys(previousValuesRef.current, trackedValues);
    console.log(`[render-profile] ${name} render #${renderCountRef.current}`, {
      changedKeys,
      trackedValues,
    });

    previousValuesRef.current = trackedValues;
  });
}

export function ProfiledSubtree({ id, children }) {
  if (!isRenderProfilingEnabled()) {
    return children;
  }

  return (
    <React.Profiler
      id={id}
      onRender={(profilerId, phase, actualDuration, baseDuration, startTime, commitTime) => {
        console.log(`[render-profile] ${profilerId} ${phase}`, {
          actualDuration,
          baseDuration,
          startTime,
          commitTime,
        });
      }}
    >
      {children}
    </React.Profiler>
  );
}
